export enum FilterOperator {
	IS_BLANK = "is_blank",
	IS_NOT_BLANK = "is_not_blank",
	IS_EQUAL_TO_STR = "is_equal_to_str",
	IS_NOT_EQUAL_TO_STR = "is_not_equal_to_str",
	CONTAINS = "contains",
	DOES_NOT_CONTAIN = "does_not_contain",
	IS_STARTING_WITH = "is_starting_with",
	IS_ENDING_WITH = "is_ending_with",

	IS_EQUAL_TO_DATE = "is_equal_to_date",
	IS_LESS_THAN_DATE = "is_less_than_date",
	IS_LESS_THAN_OR_EQUAL_TO_DATE = "is_less_than_or_equal_to_date",
	IS_GREATER_THAN_DATE = "is_greater_than_date",
	IS_GREATER_THAN_OR_EQUAL_TO_DATE = "is_greater_than_or_equal_to_date",
	IS_IN_BETWEEN_DATE = "is_in_between_date",
	IS_NOT_BETWEEN_DATE = "is_not_between_date",
	IS_IN_THE_LAST_DATE = "in_the_last_date",
	IS_IN_THE_NEXT_DATE = "in_the_next_date",
	IS_TODAY = "is_today",
	IS_YESTERDAY = "is_yesterday",
	IS_IN_THIS_WEEK = "is_in_this_week",
	IS_IN_THIS_MONTH = "is_in_this_month",
	IS_IN_LAST_WEEK = "is_in_last_week",
	IS_IN_LAST_MONTH = "is_in_last_month",
	IS_AT_TIME = "is_at_time",
	IS_BEFORE_TIME = "is_before_time",
	IS_AFTER_TIME = "is_after_time",
	IS_BETWEEN_TIME = "is_between_time",

	IS_EQUAL_TO_NUM = "is_equal_to_num",
	IS_NOT_EQUAL_TO_NUM = "is_not_equal_to_num",
	IS_LESS_THAN_NUM = "is_less_than_num",
	IS_LESS_THAN_OR_EQUAL_TO_NUM = "is_less_than_or_equal_to_num",
	IS_GREATER_THAN_NUM = "is_greater_than_num",
	IS_GREATER_THAN_OR_EQUAL_TO_NUM = "is_greater_than_or_equal_to_num",
	IS_IN_BETWEEN_NUM = "is_in_between_num",
	IS_NOT_BETWEEN_NUM = "is_bot_between_num",

	IS_TRUE = "is_true",
	IS_FALSE = "is_false",

	IS_ONE_OF = "is_one_of",

	IS_ANY_OF = "is_any_of",
	IS_NOT_ANY_OF = "is_not_any_of",
}
